import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IconEmoticonOutline = _resolveComponent("IconEmoticonOutline")
  const _component_NcActionButton = _resolveComponent("NcActionButton")
  const _component_NcActionButtonGroup = _resolveComponent("NcActionButtonGroup")
  const _component_NcActions = _resolveComponent("NcActions")

  return (_openBlock(), _createBlock(_component_NcActions, {
    variant: "tertiary",
    title: $options.t('spreed', 'Send a reaction'),
    "aria-label": $options.t('spreed', 'Send a reaction'),
    class: "reaction"
  }, {
    icon: _withCtx(() => [
      _createVNode(_component_IconEmoticonOutline, { size: 20 })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_NcActionButtonGroup, {
        class: "reaction__group",
        style: _normalizeStyle({ '--reactions-in-single-row': $options.reactionsInSingleRow })
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.supportedReactions, (reaction, index) => {
            return (_openBlock(), _createBlock(_component_NcActionButton, {
              key: index,
              "aria-label": $options.t('spreed', 'React with {reaction}', { reaction }),
              class: "reaction__button",
              onClick: $event => ($options.throttledSendReaction(reaction))
            }, {
              icon: _withCtx(() => [
                _createTextVNode(_toDisplayString(reaction), 1)
              ]),
              _: 2
            }, 1032, ["aria-label", "onClick"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["style"])
    ]),
    _: 1
  }, 8, ["title", "aria-label"]))
}